import React, { Component } from 'react';
import './OrderDetail.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import OrderData from '../Components/OrderData/OrderData';
import OrderTable from '../Components/OrderTable/OrderTable';
import closeicon from '../../image/closeicon.svg'
import axios from 'axios';
import { LinkAPI } from '../../API/API';
import HandleRes from '../Components/HandleRes/HandleRes';
import Loading from '../Components/Loading/Loading';

class OrderDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataorders: [],
            savedlocations: [],
            
            isLoading:true,
            isLoading2:true,
            reciver: "",
            phone: "",
            deliverynote: "",
            weight: "",
            pickupdate: "",
            quantity: "",
            pickupaddress_name: "",
            dropoffaddress_name: "",
            orderPrice: '',
            status: '',
            failedstatus:0,
            failedreason:'',
            totalPrice: '',
            ordernumber: '',
            qrcode: '',
            address_name: "",
            address_alias: "",
            coordinates: null,
            address_nameError: "",
            address_aliasError: "",
            res_doneTrash:false,
            res_doneReturn: false,
            res_doneconfirmorder:false,
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError:false,
        };
        this.getorderid = this.getorderid.bind(this)
       
        this.getorders = this.getorders.bind(this)
    }
   componentDidMount(){
    const id = this.props.match.params.id
    this.getorderid(id)
    this.getorders()

   }
//map
setStateField = (object) => e => {
    this.setState({
        objectaddress_name:  object.address_name,
        address_name: object.address_name,
        address_alias: object.address_alias,
        coordinates: object.location.coordinates,
    })
}
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    validateLocation = () => {
        let address_nameError = "";
        let address_aliasError = "";
        if (this.state.address_name.length < 2 || !isNaN(this.state.address_name)) {
            address_nameError = "select your location correct";
        }
        if (this.state.address_alias.length < 2 || !isNaN(this.state.address_alias)) {
            address_aliasError = "write your Address correct";
        }
        if (!this.state.coordinates) {
            address_nameError = "select your location correct";
        }
        if (address_nameError || address_aliasError) {
            this.setState({ address_nameError, address_aliasError });
            return false;
        }

        return true;
    };
    handleReturnOrderLocation = event => {
        event.preventDefault();
        const { address_name, address_alias, coordinates } = this.state
        const Token = localStorage.getItem("userToken")
        const id = this.props.match.params.id
        const isValid = this.validateLocation();
        if (isValid) {
            // clear form
            axios.post(`${LinkAPI}/api/businessowner/returnorder/${id}`, {
                dropoffLocation: {
                    address_name: address_name,
                    address_alias: address_alias,
                    location: {
                        coordinates: coordinates
                    }
                }
            }
                , {
                    headers: {
                        Authorization: `${Token}`
                    }
                }
            ).then(res => {
                this.getorderid(id)
                this.setState({
                    res_doneTrash:false,
                    res_doneReturn: true,
                    res_doneCancel: false,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError:false,
                })
                setTimeout(() => {
                    this.setState({
                        res_doneReturn:false,
                    })
            }, 2000);
            }).catch(error => {
                this.HandleError(error)

            })
        }
    };
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name

        })
  
    }
//
    HandleError = (error) => {
        if (!error.response) {
            this.setState({
                networkError: true
            })
        } else if (error.response.status === 402) {
            localStorage.removeItem("userToken")
            window.location.replace("/SignIn");
        } else if (error.response.data.message) {
            this.setState({
                errordatamessage: true,
                errordatamessagetext: error.response.data.message
            })
        } else {
            this.setState({
                hasError: true,
            })
        }
    }
    getorders = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/orders`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                dataorders: res.data.orders.reverse(),
                isLoading:false,

                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
                
            })
        }).catch(error => {
            this.HandleError(error)
        })
    }
    getorderid = (x = this.props.match.id) => {
        this.setState({
            isLoading2: true,
        })
        const Token = localStorage.getItem("userToken")
        const id = x
        axios.get(`${LinkAPI}/api/businessowner/getorder/${id}`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            if(res.data){
            this.setState(() => ({
                reciver: res.data.reciver.name,
                phone: res.data.reciver.phone,
                quantity: res.data.quantity,
                ordernumber: res.data.ordernumber,
                deliverynote: res.data.note,
                date: res.data.date,

                pickupdate: res.data.pickupDate,
                pickupaddress_name: res.data.pickupLocation.address_name,
                dropoffaddress_name: res.data.dropoffLocation.address_name,
                totalPrice: res.data.totalPrice,
                status: res.data.status,
                failedstatus:res.data.failedstatus,
                failedreason:res.data.failedreason,
                amount: res.data.amount,
                qrcode: res.data.qrcode,
                isLoading2:false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,

            }))
            
            this.getorders()
if( res.data.status===4&&res.data.failedstatus===1){
this.savedlocations()
}
        }else{
            window.location.replace("/NotFound");

        }
        }).catch(error => {
            this.HandleError(error)

        })
    }
    savedlocations = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/savedlocations`, {
            headers: {
                Authorization: `${Token}`
            }
        }).then(res => {
            this.setState({
                savedlocations: res.data.businessOwner.savedlocations,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                localStorage.setItem("userToken", '')
                window.location.replace("/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext:error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    handetrash = () => {
        const { ordernumber } = this.state
        const Token = localStorage.getItem("userToken")
        axios.put(`${LinkAPI}/api/businessowner/trashorder/${ordernumber}`, {}, {
            headers: {
                Authorization: `${Token}`
            }
        }
        ).then(res => {
           
            const id = this.props.match.params.id
            this.getorderid(id)
            this.getorders()
            this.setState({
                res_doneTrash:true,
                res_doneReturn: false,
                res_doneCancel: false,
                res_doneconfirmorder:false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
            setTimeout(() => {
                this.setState({
                    res_doneTrash:false,
                })
        }, 2000);
        }).catch(error => {
            this.HandleError(error)

        })

    }
    handelcancel = () => {
        const { ordernumber } = this.state
        const Token = localStorage.getItem("userToken")
        axios.post(`${LinkAPI}/api/businessowner/cancelorder`, {
            ordernumber: ordernumber

        }, {
                headers: {
                    Authorization: `${Token}`
                }
            }
        ).then(res => {
           
            const id = this.props.match.params.id
            this.getorderid(id)
            this.getorders()
            this.setState({
                res_doneTrash:false,
                res_doneReturn: false,
                res_doneCancel: true,
                res_doneconfirmorder:false,

                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
            setTimeout(() => {
                this.setState({
                    res_doneCancel:false,
                })
        }, 2000);
        }).catch(error => {
            this.HandleError(error)

        })

    }
    handelconfirmorder = () => {
        const Token = localStorage.getItem("userToken")
        const {pickupdate}=this.state
        const id = this.props.match.params.id
        axios.put(`${LinkAPI}/api/businessowner/confirmorder/${id}`, {pickupDate:pickupdate}, {
                headers: {
                    Authorization: `${Token}`
                }
            }
        ).then(res => {
          
            this.setState({
                res_doneTrash:false,
                res_doneReturn: false,
                res_doneCancel: false,
                res_doneconfirmorder: true,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
            setTimeout(() => {
                this.setState({
                    res_doneconfirmorder: false,
                })
        }, 2000);
            this.getorderid(id)
            this.getorders()
        }).catch(error => {
            this.HandleError(error)
        })

    }
    render() {
        document.title ="Kayn | Order Details"; 
        document.getElementsByTagName("META")[1].content="Kayn Order Details";
        document.documentElement.lang = 'en';
        return (
            <div className="AppEN">
                <div className="row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className=" OrderDetail col-md-11 px-lg-5">
                        <HeaderTool />
                        <h3 className=" fontsize9 my-0">Order #{this.state.ordernumber}</h3>
                        <div className="row">
                            <OrderTable state={this.state} getorderid={this.getorderid} />
                            {(this.state.isLoading2?<Loading/>:
                            <div className="col-md-8 px-4 py-3">
                            <OrderData state={this.state} handleChange={this.handleChange} handetrash={this.handetrash} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} handleReturnOrderLocation={this.handleReturnOrderLocation}setStateField={this.setStateField} />
                            {/* Modal  */}
                            {(this.state.status < 4&& this.state.failedstatus === 0 ?
                                <div>
                                    <div className="text-center d-flex justify-content-around flex-wrap">
                                    {(this.state.status===0?
                                        <button onClick={this.handelconfirmorder} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-white" >CONFIRM ORDER </button>
                                        :'')}
                                        <button className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " data-toggle="modal" data-target="#exampleModal"><img className="mr-1" src={closeicon} alt="close" /> CANCEL ORDER </button>

                                    </div>
                                    <div className="modal fade  " id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                        <div className="modal-dialog  " role="document">
                                            <div className="modal-content border shadow">
                                                <div className="modal-body text-center p-5">
                                                    <p className="fontsize4">Do you want to cancel tis order</p>

                                                    <button onClick={this.handelcancel} className="btn badge-pill p-2 pl-1 px-3 my-2 border shadow bg-danger text-white " data-dismiss="modal">yes</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                                </div>

                                : '')}
                            {/* ////////////// */}
                    {(this.state.failedstatus === 1&& this.state.status !== 8||this.state.failedstatus === 5?
                        <div className="col-lg-4  col-sm-5 float-right nothome text-center m-2 p-2">
                        <p className="fontsize12 m-1">Failed delivery note</p>
                        <p className="fontsize11 font-weight-bold m-0">{this.state.failedreason}</p>
                        {(this.state.failedstatus === 5?<p className="fontsize11 font-weight-bold m-0">We will try again to deliver the order to Receiver</p>:'')}
                    </div> : '')}
                        </div>
                        )}
                        </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger"/> : '')}
                {(this.state.res_doneTrash ? <HandleRes title="Order Trashed successfully" stylecss="alert-success"/> : '')}
                {(this.state.res_doneconfirmorder ? <HandleRes title="Order Confirmed successfully" stylecss="alert-success"/> : '')}
                {(this.state.res_doneReturn ? <HandleRes title="Order Returned successfully" stylecss="alert-success"/> : '')}
                {(this.state.res_doneCancel ? <HandleRes title="Order Canceled successfully" stylecss="alert-success"/> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger"/> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger"/> : '')}

            </div>
        )
    }
}
export default OrderDetail;